angular.module('unica_invitation_room.invitation_room_controllers')

.controller('InvitationRoomAssignController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	InvitationListListService, UserListService, RoomListService,
	InvitationRoomCreateService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.invitationRoomData = {};
	$rootScope.resetInvitationRoomData = function()
	{
		$rootScope.invitationRoomData = {
			event_id:      $stateParams.event_id,
			invitation_id: null,
			room_id:       null
		};
	};
	$rootScope.resetInvitationRoomData();




	/**
	 * ===================================
	 *
	 *   SEARCH ADVANCED OF USERS
	 *
	 * ===================================
	 */

	$scope.loadInvitationLists = function()
	{
		$scope.showLoader();

		InvitationListListService
			.fullList( $stateParams.event_id )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.invitationsLists = data;
				}
			});
	};

	$scope.loadInvitationLists();

	$scope.userSearchData = {};
	$scope.clearUserSearch = function() {
		$scope.userSearchData = {
			event_id: $stateParams.event_id,
			status:  'confirmed',
			no_room:  false
		};
		$scope.userList = [];
	};
	$scope.clearUserSearch();

	$scope.userList = [];
	$scope.advancedUserSearch = function()
	{
		$scope.showLoader();

		UserListService
			.advancedSearch( $scope.userSearchData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.userList = data;
				}
			});
	};
	/**
	 * =================================== *
	 */



	$scope.openImportInvitationRoomAssignModal = function ()
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalImportInvitationRoomAssignInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/import-invitation-room.html',
			size: 'lg',
			windowClass: 'modal-invitation-list'
		});

		modalInstance.result.then(function (data) {

			if ( data.result == 'ok' ) {
				$scope.showSuccessMsg('Assegnati: ' + data.created.length + ' - Saltati: ' + data.skipped.length );

				$state.go('app.hospitality.invitation_room_list', { event_id: $stateParams.event_id });
			}

		}, function () { });
	};



	/**
	 * ===================================
	 *
	 *   SEARCH ROOMS
	 *
	 * ===================================
	 */

	$scope.roomSearchData = {};

	$scope.clearRoomSearch = function() {
		$scope.roomSearchData = {
			event_id: $stateParams.event_id,
			no_invitation: true
		};
		$scope.roomList = [];
	};
	$scope.clearRoomSearch();

	$rootScope.getHotelList();

	$scope.roomList = [];
	$scope.advancedRoomSearch = function()
	{
		$scope.showLoader();

		RoomListService
			.search( $stateParams.event_id, $scope.roomSearchData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.roomList = data;
				}
			});
	};
	$scope.advancedRoomSearch();





	/**
	 * ===================================
	 *
	 *   ASSIGN ROOM
	 *
	 * ===================================
	 */

	$scope.saveInvitationRoom = function()
	{
		$scope.showLoader();

		InvitationRoomCreateService
			.create( $rootScope.invitationRoomData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Assegnazione Stanza avvenuta con successo!', '');
					$scope.postAssign();
				}
			});

	};


	/**
	 * ===================================
	 *
	 *   POST ROOM ASSIGN
	 *
	 * ===================================
	 */
	$scope.postAssign = function()
	{
		// for ( var i = 0; i < $scope.userList.length; i++ ) {
		// 	if ( $rootScope.invitationRoomData.invitation_id === $scope.userList[i].invitation_id ) {
		// 		$scope.userList.splice(i, 1);
		// 	}
		// }

		for ( var i = 0; i < $scope.roomList.length; i++ ) {
			if ( $rootScope.invitationRoomData.room_id === $scope.roomList[i].id ) {
				$scope.roomList.splice(i, 1);
			}
		}
	};

})
	.controller('ModalImportInvitationRoomAssignInstanceController',
		function (
			$scope, $stateParams, $rootScope,
			$uibModalInstance, FileUploader, getBaseApiURL, Session
		) {

			$scope.importInvitationAssignmentsData = {
				csv: ''
			};

			$scope.uploader = new FileUploader({
				removeAfterUpload: true,
				alias: 'csv',
				url: getBaseApiURL + '/import/assign-invitation-room/' + $stateParams.event_id,
				headers: {
					Authorization : 'Bearer ' + Session.token,
					Accept: 'application/json'
				}
			});

			$scope.uploader.onCompleteItem = function(fileItem, response) {
				$scope.hideLoader();
				if ( response.result === 'ko' && response.message ) {
					$rootScope.showErrorMsg( response.message );
				} else {
					$scope.showSuccessMsg('Operazione completata');
				}
				$uibModalInstance.close( response );
			};

			$scope.deleteImportInvitationAssignmentsCsv = function() {
				angular.element(document.querySelector('.assignments_csv')).val(null);
			};

			$scope.importInvitationAssignments = function () {
				$scope.showLoader();
				$scope.uploader.uploadAll();
			};

			$scope.closeModal = function() {
				$uibModalInstance.dismiss('cancel');
			};

		});